import { Navigate, Outlet } from 'react-router';

import { useRole } from '@/hooks/use-role';
import type { Role } from '@/types';

const HOME_ROUTE: Record<Role, string> = {
  owner: '/jobs',
  employee: '/schedule',
  customer: '/jobs',
};

interface Props {
  role: 'owner' | 'employee';
}

/** Redirects a signed-in user away from a route gated to the other role. */
export function RequireRole({ role }: Props) {
  const { role: current } = useRole();

  if (current && current !== role) {
    return <Navigate to={HOME_ROUTE[current]} replace />;
  }

  return <Outlet />;
}
